import React, { useState } from 'react';
import { Field, FieldInput } from './SectionBar.styled';

export interface SectionValueFieldProps {
  label: string;
  unit: string;
  value: number;
  /** Called with the typed value on Enter or blur; the caller clamps it. */
  onCommit: (value: number) => void;
  testId: string;
}

const display = (value: number) => String(Math.round(value * 10) / 10);

/** A number typed in place: Enter or leaving the field commits it, Esc puts the value back. */
const SectionValueField: React.FC<SectionValueFieldProps> = ({ label, unit, value, onCommit, testId }) => {
  const [draft, setDraft] = useState<string | null>(null);
  const [shown, setShown] = useState(value);
  if (value !== shown) {
    setShown(value);
    setDraft(null);
  }
  const commit = () => {
    if (draft === null) return;
    const typed = draft.replace(',', '.').trim();
    setDraft(null);
    const parsed = Number(typed);
    if (typed !== '' && Number.isFinite(parsed)) onCommit(parsed);
  };
  return (
    <Field>
      <span>{label}</span>
      <FieldInput
        inputMode="decimal"
        aria-label={`${label} (${unit})`}
        value={draft ?? display(value)}
        onChange={(event) => setDraft(event.target.value)}
        onBlur={commit}
        onKeyDown={(event) => {
          if (event.key === 'Enter') commit();
          if (event.key === 'Escape') {
            event.stopPropagation();
            setDraft(null);
          }
        }}
        data-testid={testId}
      />
      <span>{unit}</span>
    </Field>
  );
};

export default SectionValueField;
